import * as Mui from "@mui/material";
import { Pane, Spinner } from "evergreen-ui";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { CategoriesSelect } from "components";

const ProductForm = ({
  initialValues,
  urunKategori,
  setUrunKategori,
  urunArticle,
  setUrunArticle,
  values,
  errors,
  categories,
  articles,
  handleChangeEditor,
  content,
  combinedHandleChange,
}) => {
  const renderArticleOptions = () => {
    if (articles.isLoading) {
      return (
        <Pane>
          <Spinner marginX="auto" size={50} />
        </Pane>
      );
    }

    if (!articles.isError) {
      return (
        <>
          <Mui.InputLabel id="demo-simple-select-label">
            Ürün Makalesi
          </Mui.InputLabel>
          <Mui.Select
            defaultValue=""
            key={""}
            size="small"
            labelId="demo-simple-select-label"
            id="demo-simple-select2"
            value={urunArticle}
            label="Ürün Makalesi"
            onChange={(e) => setUrunArticle(e.target.value)}
          >
            <Mui.MenuItem value={0}>Makale Seçiniz</Mui.MenuItem>
            {articles.data.length > 0 &&
              articles.data.map((row, i) => (
                <Mui.MenuItem key={i} value={row.id}>
                  {row.title}
                </Mui.MenuItem>
              ))}
          </Mui.Select>
        </>
      );
    }

    return (
      <Mui.Select
        defaultValue={urunArticle}
        key={urunArticle}
        size="small"
        labelId="demo-simple-select-label"
        id="demo-simple-select2"
        value={urunArticle}
        label="Ürün Makalesi"
      >
        <Mui.MenuItem value={0}>Makale Bulunamadı</Mui.MenuItem>
      </Mui.Select>
    );
  };

  return (
    <div className="grid grid-cols-1 gap-6">
      <Mui.FormControl fullWidth>
        <Mui.TextField
          sx={{ m: 0 }}
          size="small"
          margin="normal"
          required
          fullWidth
          id="title"
          label="Başlık"
          name="title"
          autoComplete="title"
          onChange={combinedHandleChange}
          defaultValue={initialValues.title}
          key={initialValues.title}
          values={values.title}
          helperText={errors.title && errors.title}
          error={errors.title ? true : false}
        />
      </Mui.FormControl>
      <div className="w-full flex items-center gap-5">
        <Mui.FormControl fullWidth>
          <CategoriesSelect
            data={categories}
            urunKategori={urunKategori}
            handleOnChange={setUrunKategori}
            defaultTitle="Kategori Seçin"
          />
        </Mui.FormControl>
        <Mui.FormControl fullWidth>{renderArticleOptions()}</Mui.FormControl>
      </div>
      <Mui.FormControl fullWidth sx={{ mb: 5 }}>
        <ReactQuill
          value={content}
          onChange={handleChangeEditor}
          theme={"snow"}
        />
      </Mui.FormControl>
    </div>
  );
};

export default ProductForm;
